/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = { appearances: {}, rules: [], tokens: { maxLines: 4, minLines: 2 } }
export default theme
